@for (column of columns(); track $index) {
    <td
        (contextmenu)="open.set(true)"
        (clickOutside)="open.set(false)"
        [cdkContextMenuTriggerFor]="context"
        gridCell
        [(selecteds)]="selecteds"
        [attr.data-theme]="theme()"
        [attr.data-fixed]="column?.type === 'checkbox'"
        [attr.data-selected]="selected() || active() || open()"
        [class.cursor-pointer]="column.cellClickHandler"
        [class.group-hover:bg-dark]="theme() === 'dark'"
        [class.group-hover:bg-primary-50]="theme() === 'light'"
        [column]="column"
        [row]="row()"
    ></td>
}

<ng-template #context>
    @if (rowOptions(); as options) {
        @if (options.length > 0) {
            <app-menu cdkMenu>
                @for (option of options; track option) {
                    @if (option.children) {
                        <app-menu-option [icon]="option.icon" (click)="handleChildren(option)">
                            <div class="flex items-center justify-between w-full">
                                <span>{{ option.label }}</span>
                                <app-icon name="solar:alt-arrow-right-line-duotone"></app-icon>
                            </div>
                            @if (option.children; as children) {
                                @if (childOpen()) {
                                    <div class="absolute top-0 left-full">
                                        <app-menu cdkMenu>
                                            @for (item of children.items(row()); track item) {
                                                <app-menu-option (click)="childHandleOption(children, item)" cdkMenuItem>{{
                                                    item[children.label]
                                                }}</app-menu-option>
                                            }
                                        </app-menu>
                                    </div>
                                }
                            }
                        </app-menu-option>
                    } @else {
                        <app-menu-option [icon]="option.icon" (click)="handleOption(option)" cdkMenuItem>{{
                            option.label
                        }}</app-menu-option>
                    }
                }
            </app-menu>
        }
    }
</ng-template>
